import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Link } from "react-router-dom";
import Grid from '@material-ui/core/Grid';
import Navbar from '../navbar/Navbar'
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import Button from '@material-ui/core/Button';
import './Community.css'
import '../notes/notes.css'

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
}));

export default function FullWidthGrid() {
  const classes = useStyles();

  return (
    <div className={classes.root} style={{marginTop:'-10px'}}>
        <Navbar/>
        <Link id='back' to="/">
                <Button style={{ margin: '10px',marginTop:'80px' }} variant="contained" color="primary" href="#contained-buttons">
                    <KeyboardBackspaceIcon />
                </Button>
            </Link>
      <Grid container spacing={3} justify="center">
        <Grid item xs={12} sm={8}>
    
          <iframe style={{width:'100%', height:'100vh', marginTop:'-50px'}} src="https://viewshare98912061.wordpress.com"></iframe>
          <h3 style={{ textAlign: 'center', color: 'blue' }}>Engage with our services bellow.</h3>


        </Grid>
        
      </Grid>
    </div>
  );
}
